import ScrollToTop from '@atoms/ScrollToTops/ScrollToTop';
import { LoginCheck } from '@helpers/index';
import ErrorBoundary from '@organisms/Errors/ErrorBoundary';
import Footer from '@organisms/Footers/Footer';
import { Header } from '@organisms/Headers';
import { Side } from '@organisms/Menus';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
    children: ReactNode;
};

const Common = (props: Props) => {
    LoginCheck();
    return (
        <Container>
            <HeaderWithStyled>
                <ErrorBoundary><Header /></ErrorBoundary>
            </HeaderWithStyled>
            <BodyWithStyled className='main'>
                <ErrorBoundary><Side /></ErrorBoundary>
                <RightWithStyled className='mainContents'>
                    <MainWithStyled>
                        <ErrorBoundary>{props.children || ''}</ErrorBoundary>
                        <ErrorBoundary><ScrollToTop /></ErrorBoundary>
                    </MainWithStyled>
                    <FooterWithStyled>
                        <ErrorBoundary><Footer /></ErrorBoundary>
                    </FooterWithStyled>
                </RightWithStyled>
            </BodyWithStyled>
        </Container>
    );
};

const Container = styled.div`
`
const HeaderWithStyled = styled.div`
`
const BodyWithStyled = styled.div`
`
const RightWithStyled = styled.div`
`
const MainWithStyled = styled.div`
`
const FooterWithStyled = styled.div`
    width: 100%;
    padding: 24px 0 0;
    margin-top: auto;
`

export default Common;